export default {
  event(action: string, name: string, props: any = null) {
    if ((window as any).fbq) {
      (window as any).fbq(action, name, props);
    }
  },
};
